import { render, staticRenderFns } from "./ModalDuplicateTemplateBlock.vue?vue&type=template&id=7421b1c6"
import script from "./ModalDuplicateTemplateBlock.vue?vue&type=script&lang=js"
export * from "./ModalDuplicateTemplateBlock.vue?vue&type=script&lang=js"
import style0 from "./ModalDuplicateTemplateBlock.vue?vue&type=style&index=0&id=7421b1c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports